import ReservationForm from "../../components/ReservationForm";

export default function EditReservation() {
  return (
    <>
      <h1 className="text-center">Edit Reservation</h1>
      <ReservationForm />
    </>
  );
}